export default class AddLineDataFormatter {
  static formatNumber(number) {
    if (number === null || number === undefined) return '0'

    const num = Number(number)
    if (isNaN(num)) return '0'

    const absNum = Math.abs(num)
    let value = num
    let suffix = ''

    if (absNum >= 1000000000) {
      value = num / 1000000000
      suffix = 'B'
    } else if (absNum >= 1000000) {
      value = num / 1000000
      suffix = 'M'
    } else if (absNum >= 1000) {
      value = num / 1000
      suffix = 'K'
    } else {
      return Math.round(num).toLocaleString()
    }

    const fixed = value.toFixed(2)
    const trimmed = fixed.replace(/\.00$/, '').replace(/(\.[1-9])0$/, '$1')
    return `${trimmed}${suffix}`
  }

  static formatPercent(number) {
    if (number === null || number === undefined || isNaN(Number(number))) return '-'

    return `${Number(number).toFixed(2)}%`
  }

  // Parses the single Add Lines search field. Untagged text ("myapp") is sent as-is to
  // the backend's OR-across-fields search filter. Tagged text ("uuid:abc", "bundle:123",
  // "deal:456", "app:myapp") targets exactly one of the existing single-field filters
  // instead, bypassing the OR search.
  static parseSearchInput(text) {
    const trimmed = (text || '').trim()
    if (!trimmed) return null

    const tagMatch = trimmed.match(/^(\w+):(.+)$/)
    if (tagMatch) {
      const tagFieldMap = {
        uuid: 'uuid',
        bundle: 'bundle-id',
        bundle_id: 'bundle-id',
        deal: 'deal-id',
        deal_id: 'deal-id',
        app: 'app-name',
        app_name: 'app-name',
        name: 'app-name'
      }
      const field = tagFieldMap[tagMatch[1].toLowerCase()]
      const value = tagMatch[2].trim()
      if (field && value) return {field, value}
    }

    return {field: 'search', value: trimmed}
  }

  static getCategoryName(categoryId) {
    if (!categoryId) return null

    let numericId = categoryId
    if (window.ssbAppCategoryEnumToId && window.ssbAppCategoryEnumToId[categoryId]) {
      numericId = window.ssbAppCategoryEnumToId[categoryId]
    }

    if (window.ssbAppCategories && window.ssbAppCategories[numericId]) {
      return window.ssbAppCategories[numericId].label
    }

    return 'Unknown Category'
  }

  static getExchangeName(exchangeId) {
    if (!exchangeId) return null

    if (window.ssbExchanges && window.ssbExchanges[exchangeId]) {
      return window.ssbExchanges[exchangeId]
    }

    return `Exchange ${exchangeId}`
  }

  static getAdTypeName(adType) {
    if (!adType) return null

    if (window.ssbAdTypeIdToName && window.ssbAdTypeIdToName[adType]) {
      return window.ssbAdTypeIdToName[adType]
    }

    return adType
  }

  static getImpTypeName(impType) {
    if (!impType) return null

    if (window.ssbImpTypeIdToName && window.ssbImpTypeIdToName[impType]) {
      return window.ssbImpTypeIdToName[impType]
    }

    return impType
  }

  static getHistoryStatusText(line) {
    const planStatus = line.planStatus || line['plan-status']
    const blocked = line.blocked ? ' | Blocked' : ''

    switch (planStatus) {
      case 'active':
        return ` | Active in Plan${blocked}`
      case 'removed':
        return ` | Was in Plan${blocked}`
      case 'never':
      default:
        return blocked
    }
  }

  static getStoreUrl(appId) {
    return `/apps/${appId}`
  }

  static buildSortParam(sortField, sortDirection) {
    if (!sortField) return ''

    const direction = sortDirection === 'desc' ? '-' : ''

    const fieldMapping = {
      'trafficNumber': 'traffic-number',
      'appName': 'app-name',
      'categoryId': 'category-id',
      'adType': 'ad-type',
      'impType': 'imp-type',
      'dealId': 'deal-id'
    }

    const apiField = fieldMapping[sortField] || sortField
    return `${direction}${apiField}`
  }

  static buildSelectOptions(items, valueKey = 'id', labelKey = 'label') {
    return items.map(item => {
      const label = item[labelKey]
      const count = item.count !== undefined ? ` (${item.count} Apps)` : ''
      return `<option value="${item[valueKey]}">${label}${count}</option>`
    }).join('')
  }

  static getBuuid() {
    // Use global SSBBUUID variable if available (set from meta tag)
    if (typeof window.SSBBUUID !== 'undefined') {
      return window.SSBBUUID
    }

    // Fallback to URL parsing for backward compatibility
    const pathSegments = window.location.pathname.split('/')
    const buyerIdIndex = pathSegments[1] === 'ssb' ? 2 : 1
    return pathSegments[buyerIdIndex] || ''
  }
}
